
import { Vue, Component, Prop } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import { configStore } from "@/store/store";

@Component({
  components: {
    IconButton
  }
})
export default class PanelHeader extends Vue {
  @Prop({ default: false })
  backInsteadOfClose!: boolean;

  close() {
    this.$emit("close");
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
